import { useQuery } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { Project, Resource } from '@/types/types';
import { API_URL } from '@/lib/apiUrl';

export const useResource = ({
  id,
  projectId,
}: {
  id: Resource['id'];
  projectId?: Project['id'];
}) => {
  const { axiosInstance } = useApi();

  return useQuery({
    queryKey: queryKeys.resources.detail(id).queryKey,
    queryFn: async () => {
      const { data } = await axiosInstance.get<Resource>(
        `${API_URL}/api/v1/resources/${id}`,
        {
          params: {
            project_id: projectId,
          },
        }
      );
      return data;
    },
  });
};

export default useResource;
